import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AdminService } from '../services/admin.service';

@Injectable({ providedIn: 'root' })
export class EmailDomainBlacklistValidator implements AsyncValidator {
  constructor(private adminService: AdminService) {}
  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const email: string = control.value;
    if (email == null) {
      return of(null);
    }
    const split = email.split('@');
    if (split.length !== 2) {
      //We don't have two sections. Not a valid email, but this validator doesn't handle that.
      return of(null);
    }
    return this.adminService.getEmailDomainBlacklist().pipe(
      map(result => {
        if (!result.Domains.includes(split[1].toLowerCase())) {
          return null;
        } else {
          return { blacklistedDomain: split[1].toLowerCase() };
        }
      })
    );
  }
}
